module.exports = __webpack_public_path__ + "static/img/Jack_Macrae_mobile.a0c5b3f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jack_Macrae_mobile.jpg
// module id = TUGS
// module chunks = 0